import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    slideRoot: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
    },
    title: {
        color: theme.palette.text.secondary,
        paddingBottom: theme.spacing(3),
        fontSize: "24px !important",
        borderBottom: `1px solid ${theme.palette.border.main}`,
        width: "100%",
        textAlign: "start",
    },
    graphContainer: {
        display: "flex",
        flex: 1,
        minHeight: 0,
        justifyContent: "flex-start",
        position: "relative",
        padding: `${theme.spacing(3)} ${theme.spacing(6)} 0 ${theme.spacing(6)}`,
        overflowX: "auto",
        overflowY: "hidden",
    },
    graphGridItemContainer: {
        height: "100%",
        minWidth: 1000,
        marginBottom: theme.spacing(1),
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.graphs.main,
        },
    },
    graphTitle: {
        margin: `${theme.spacing(2)} 0 !important`,
        textAlign: "center",
    },
}));
